<template>
  <div id="forgetusernamemain">
    <span class="titleline"  @click="checkLogin()">返回登陆</span>
    <label class="loginLable" style="margin-top: 10%;margin-bottom: 20%;">用户名找回</label>

    <el-form ref="forgotForm" :model="forgotForm" :rules="forgotFormRules">
      <el-form-item prop="username">
        <el-input ref="input" prefix-icon="iconfont icon-login-username" v-model="forgotForm.username" placeholder="请输入会员申请填写的邮箱"
          style="width: 65%;">
        </el-input>
        <button class="yzmbtn" type="button" @click="getMessageCode()"
          v-text="messageCodeText" :disabled="mobileBtnDisabled"></button>
      </el-form-item>

      <el-form-item prop="yanzhengma">
        <el-input prefix-icon="iconfont icon-login-password" class="iconStyle" v-model="forgotForm.yanzhengma"
          placeholder="请输入验证码">
        </el-input>
      </el-form-item>

      <div class="div1">
        <div>
          <span @click="checkForgot()" class="span1">
            忘记密码</span>
        </div>
      </div>

      <div class="login-btn" style="">
        <el-button size="medium" @click="findUsername('forgotForm')" type="primary">立即找回</el-button>
      </div>

    </el-form>
  </div>
</template>

<script>
  var code; //在全局定义验证码
  export default {
    name:'forgetusernamemain',
    data() {
      var validateMail = (rule, value, callback) => {
        if (value == "" || value == null) {
          return callback(new Error('请输入邮箱'));
        } else if (!/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@[0-9A-Za-z]+(?:\.[0-9A-Za-z]+)+$/.test(value)) {
          return callback(new Error('请输入正确邮箱'));
        } else {
          callback();
        }
      };
      var validateYan = (rule, value, callback) => {
        if (value == "" || value == null) {
          return callback(new Error('请输入验证码'));
        } else if (value == this.messageCodeReal && this.messageCodeReal != "") {
          callback();
        } else {
          return callback(new Error('验证码错误'));
        }
      };
      return {

        checkCode: '',
        // 校验标识符
        usernameAlertFlag: false,
        passwordAlertFlag: false,
        password2AlertFlag: false,
        messageCodeAlertFlag: false,
        forgotForm: {
          username: "",
          password: "",
          password1: "",
          yanzhengma: ""
        },
        forgotFormRules: {
          username: [{
            validator: validateMail,
            trigger: "blur"
          }],
          yanzhengma: [{
            validator: validateYan,
            trigger: "blur"
          }],
        },
        messageCodeText: "获取验证码",
        mobileBtnDisabled: false,
        messageCodeReal: "",
        time: 60,
      }
    },
    created() {},
    methods: {
      init:function(){
         this.$refs["forgotForm"].resetFields()
      },
      checkLogin: function() {
        this.$parent.isLogin = true;
        this.$parent.isRegister = false;
        this.$parent.isForgot = false;
        this.$parent.isForgotUsername = false;
        this.$parent.$refs.loginmain.init();
      },
      checkForgot: function() {
        this.$parent.isLogin = false;
        this.$parent.isRegister = false;
        this.$parent.isForgot = true;
        this.$parent.isForgotUsername = false;
        this.$parent.$refs.forgetpasswordmain.init();
      },
      // 验证用户名是否为邮箱
      mailCheck: function() {
        var name = "";
        name = this.forgotForm.username;
        if (!/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@[0-9A-Za-z]+(?:\.[0-9A-Za-z]+)+$/.test(name)) {
          this.mailAlertFlag = true;
          return false;
        } else {
          this.mailAlertFlag = false;
          return true;
        }
      },

      //找回用户名
      findUsername: function(formName) {
        this.$refs[formName].validate(valid => {
          let vm = this;

          if (valid) {
            vm.$axios.get("/signin/getMailNum/" + vm.forgotForm.username + "/static").then(
              function(res) {
                if (res.data.result == 0) {

                  this.$alert('该邮箱未注册', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {}
                  });
                } else if (res.data.result == 1) {
                  vm.$axios.get("/signin/getUsernameByMail/" + vm.forgotForm.username + "/static").then(
                    function(res) {

                      this.$alert('用户名找回成功', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                          this.$refs[formName].resetFields()

                          this.$parent.userName = res.data;
                          //vm.changeForm("loginFlag");
                          this.$parent.checkLogin();

                        }
                      });

                    }.bind(vm),
                    function(error) {
                      console.log(error);
                    }
                  );
                }
              }.bind(vm),
              function(error) {
                console.log(error);
              });
          }
        });
      },
      //获取邮箱验证码
      getMessageCode: function() {

        this.$nextTick(() => { //自动获取焦点 element组件autofocus失效
          this.$refs.input.$refs.input.focus()
        })
        if (this.forgotForm.username == "" || this.forgotForm.username == null) {
          this.$nextTick(() => { //自动获取焦点 element组件autofocus失效
            this.$refs.input.$refs.input.blur()
          })
        } else {
          let vm = this;
          vm.messageCode = "";
          if (vm.mailCheck()) {
            vm.messageCodeText = "发送中...";
            vm.mobileBtnDisabled = true;
            vm.$axios.get("/signin/getMailNum/" + vm.forgotForm.username + "/static").then(
              function(res) {

                if (res.data.result == 0) {
                  this.$alert('用户不存在', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      vm.messageCodeText = "获取验证码";
                      vm.mobileBtnDisabled = false;
                    }
                  });

                } else {
                  vm.$axios.get("/signin/sendMail?mail=" + vm.forgotForm.username).then(
                    function(res) {

                      vm.messageCodeReal = res.data.msg;
                      var count = vm.time;
                      vm.timer = setInterval(() => {
                        if (count == 0) {
                          clearInterval(vm.timer);
                          vm.timer = null;
                          vm.messageCodeText = "获取验证码";
                          vm.mobileBtnDisabled = false;
                        } else {
                          vm.messageCodeText = count + "秒后获取";
                          count--;
                          vm.mobileBtnDisabled = true;
                        }
                      }, 1000);
                    }.bind(vm),
                    function(error) {
                      console.log(error);
                    }
                  );
                }
              }.bind(vm),
              function(error) {
                console.log(error);
              }
            );
          }
        }
      },
    }
  };
</script>
<style lang="scss">
#forgetusernamemain{
  .div1{
    display: block;
    position: absolute;
    right: 0;
    bottom: 3rem;
    text-align: right;
  }
  .span1{
    font-size: 1rem;
    color: #409eff;
    display: inline-block;
    width: auto;
    height: auto;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/login/ForgetUsername.vue